import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment
} from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthServiceProvider, UserServiceInterface } from 'common';
import { catchError, finalize, map, mergeMap, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class IsLoggedGuard implements CanActivate, CanLoad {
  public loader = false;

  constructor(private authProvider: AuthServiceProvider,
              @Inject('UserService') private userService: UserServiceInterface,
              private router: Router) {
  }

  canActivate(_: ActivatedRouteSnapshot, _2: RouterStateSnapshot): Observable<boolean> {
    return this.authProvider.getService()
      .pipe(
        tap(() => this.loader = true),
        mergeMap((service) => service.isLogged()),
        map(logged => {
          if (!logged) {
            this.redirectToLogin();
          }
          return logged;
        }),
        mergeMap((logged) => (logged ? this.userService.refreshUser({forceReload: true}) : of(void 0))
          .pipe(map(() => logged))
        ),
        finalize(() => this.loader = false),
        catchError(() => {
          this.loader = false;
          this.redirectToLogin();
          return of(false);
        }),
      );
  }

  canLoad(_: Route, _2: UrlSegment[]): Observable<boolean> {
    return this.authProvider.getService()
      .pipe(
        mergeMap(service => service.isLogged()),
        map(logged => {
          if (!logged) {
            this.redirectToLogin();
          }
          return logged;
        }),
      );
  }

  private redirectToLogin() {
    this.router.navigate([environment['forcedCompanyName'] ? '/sso/login' : '/authentication/login']);
  }
}
